import React from "react";
import styled from "styled-components";
import {inject, observer} from "mobx-react";
import ButtonBase from "@material-ui/core/ButtonBase";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListSubheader from "@material-ui/core/ListSubheader";
import Tooltip from "@material-ui/core/Tooltip";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import mlbSportyLogo from "images/sporty-logo.png";
import milbSportyLogo from "images/sporty-logo-milb.png";
import mlbIcon from "images/mlb.png";
import milbIcon from "images/milb.png";
import {CONTENT_EXPERIENCE} from "../utils/constants";

const EXPERIENCE_META = {
  [CONTENT_EXPERIENCE.MLB]: {
    logo: mlbSportyLogo,
    icon: mlbIcon,
    label: "MLB",
    description: "MLB Plays & Forge MLB Content"
  },
  [CONTENT_EXPERIENCE.MILB]: {
    logo: milbSportyLogo,
    icon: milbIcon,
    label: "MiLB",
    description: "Forge MiLB Content"
  }
};

const Logo = styled.img`
  && {
    width: 200px;
    display: block;
  }
`;

const MenuLogo = styled.img`
  && {
    height: 24px;
    display: block;
  }
`;

const MenuLabel = styled.span`
  && {
    margin-left: 16px;
    font-weight: 700;
    color: #002D72;
  }
`;

// region style consts
const LOGO_WHITESPACE = 36;
const TOOLBAR_GUTTER = 24;

const CHEVRON_SIZE = 20;
const CHEVRON_GAP = 6;
const CHEVRON_RIGHT_PAD = 28;

// 3ndregion

// A dark overlay box fades in over the whole trigger (logo + surrounding whitespace)
// on hover. Dim the entire padding box via an ::after overlay.
const Trigger = styled(ButtonBase)`
  && {
    position: relative;
    align-self: stretch;
    margin-left: -${TOOLBAR_GUTTER}px;
    padding: 0 ${CHEVRON_RIGHT_PAD}px 0 ${LOGO_WHITESPACE}px;
    display: inline-flex;
    align-items: center;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.20);
      opacity: 0;
      transition: opacity 0.15s ease-in-out;
      pointer-events: none;
    }

    &:hover::after, &.Mui-focusVisible::after {
      opacity: 1;
    }
  }
`;

class ExperienceLogoSelector extends React.Component {
  state = {
    anchorEl: null
  };

  handleOpen = event => {
    this.setState({anchorEl: event.currentTarget});
  };

  handleClose = () => {
    this.setState({anchorEl: null});
  };

  handleSelect = experience => {
    this.props.experienceStore.setExperience(experience);
    this.handleClose();
  };

  render() {
    const {experienceStore, authStore} = this.props;
    const {anchorEl} = this.state;
    const {resolvedExperience, allowedExperiences} = experienceStore;

    // Until the user is authenticated (e.g. the login page) entitlement is unknown,
    // so render a plain, non-interactive default logo. No chevron, no menu ...
    if (!authStore.isAuthenticated || allowedExperiences.length <= 1) {
      const staticLogo = authStore.isAuthenticated
        ? (EXPERIENCE_META[resolvedExperience] || EXPERIENCE_META[CONTENT_EXPERIENCE.MLB]).logo
        : EXPERIENCE_META[CONTENT_EXPERIENCE.MLB].logo;
      return (
          <Logo
              src={staticLogo}
              alt="Sporty"
              style={{marginLeft: LOGO_WHITESPACE - TOOLBAR_GUTTER, marginRight: LOGO_WHITESPACE}}
          />
      );
    }

    const activeLogo = (EXPERIENCE_META[resolvedExperience] || EXPERIENCE_META[CONTENT_EXPERIENCE.MLB]).logo;

    return (
        <React.Fragment>
          <Trigger
              onClick={this.handleOpen}
              aria-controls="experience-menu"
              aria-haspopup="true"
              aria-label="Select experience"
          >
            <Logo src={activeLogo} alt="Sporty"/>
            <ExpandMoreIcon
                style={{
                  color: "#9e9e9e",
                  fontSize: CHEVRON_SIZE,
                  marginLeft: CHEVRON_GAP
                }}
            />
          </Trigger>
          <Menu
              id="experience-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
              getContentAnchorEl={null}
              marginThreshold={0}
              anchorOrigin={{vertical: "bottom", horizontal: "left"}}
              transformOrigin={{vertical: "top", horizontal: "left"}}
              PaperProps={{
                style: anchorEl ? {width: anchorEl.offsetWidth} : undefined
              }}
          >
            <ListSubheader
                disableSticky
                style={{
                  paddingLeft: LOGO_WHITESPACE,
                  lineHeight: "36px",
                  textTransform: "uppercase",
                  fontSize: "0.75rem",
                  letterSpacing: "0.5px"
                }}
            >
              Choose Experience
            </ListSubheader>
            {allowedExperiences.map(experience => (
                <Tooltip
                    key={experience}
                    title={EXPERIENCE_META[experience].description || ""}
                    placement="right"
                >
                  <MenuItem
                      selected={experience === resolvedExperience}
                      onClick={() => this.handleSelect(experience)}
                      style={{paddingLeft: LOGO_WHITESPACE}}
                  >
                    <MenuLogo
                        src={EXPERIENCE_META[experience].icon}
                        alt={EXPERIENCE_META[experience].label}
                    />
                    <MenuLabel>{EXPERIENCE_META[experience].label}</MenuLabel>
                  </MenuItem>
                </Tooltip>
            ))}
          </Menu>
        </React.Fragment>
    );
  }
}

export default inject("experienceStore", "authStore")(observer(ExperienceLogoSelector));



// WEBPACK FOOTER //
// ./src/components/ExperienceLogoSelector.js